export default __webpack_public_path__ + "static/media/research-lang.b3d3e93c.jpg";